import { render, staticRenderFns } from "./PricePlansTable.vue?vue&type=template&id=64de7e9e&"
import script from "./PricePlansTable.vue?vue&type=script&lang=ts&"
export * from "./PricePlansTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTd,QCheckbox,QBtnGroup,QBtn} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTd,QCheckbox,QBtnGroup,QBtn}, component.options.components || {})
